module.exports = __webpack_public_path__ + "static/HUB2-68616b47c1bac1da8ab2e65c1d6ef720.png";